import React, { FC, useEffect, useId, useRef, useState } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import ProductCard from "./ProductCard";
import { Product, PRODUCTS } from "data/data";

import { BEARER_TOKEN } from '../../src/store/config';
import axios from "axios";

export interface SectionSliderProductCardProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  headingFontClassName?: string;
  headingClassName?: string;
  subHeading?: string;
  data?: Product[];
}

interface SliderItem {
  sliderId: number;
  description: string;
  imageName: string;
}

const SectionSliderProductCard: FC<SectionSliderProductCardProps> = ({
  className = "",
  itemClassName = "",
  headingFontClassName,
  headingClassName,
  heading,
  subHeading = ""
}) => {
  const sliderRef = useRef(null);
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");
  const [productsIndexPresentation, setProductsIndexPresentation] = useState<SliderItem[]>([]);

    useEffect(() => {
      const fetchPaymentMethods = async () => {
        try {
          setProductsIndexPresentation([
            { sliderId: 1, description: "", imageName: "pagina web-06.png" },
            { sliderId: 2, description: "", imageName: "pagina web-07.png" },
            { sliderId: 3, description: "", imageName: "pagina web-08.png" },
            { sliderId: 4, description: "", imageName: "pagina web-09.png" },
          ]);
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchPaymentMethods();
    }, []); 

    useEffect(() => {
      if (!sliderRef.current) return;
      if (productsIndexPresentation.length === 0) return;
    
    const OPTIONS: Partial<Glide.Options> = {
      perView: 4,
      gap: 32,
      bound: false,
      breakpoints: {
        1280: {
          perView: 4 - 1,
        },
        1024: {
          gap: 20,
          perView: 4 - 1,
        },
        768: {
          gap: 20,
          perView: 4 - 2,
        },
        640: {
          gap: 20,
          perView: 1.5,
        },
        500: {
          gap: 20,
          perView: 1.3,
        },
      },
    };
    
      const slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
      slider.mount();
    
      return () => {
        slider.destroy();
      };
    }, [productsIndexPresentation, UNIQUE_CLASS]);
    

  return (
  <div className={`nc-SectionSliderProductCard ${className}`}>
    <div className={`${UNIQUE_CLASS} flow-root`} ref={sliderRef}>
      <Heading
        isCenter
        className="text-[#671be5] mb-12" // 👈 color violeta + margen inferior
        fontClass="text-3xl md:text-4xl font-bold" // 👈 más grande y negrita
        rightDescText={subHeading}
        hasNextPrev={false}
      >
        PRODUCTOS
      </Heading>

      <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides flex justify-center gap-8">
          {productsIndexPresentation.map((item, index) => (
            <li key={index} className={`glide__slide flex justify-center ${itemClassName}`}>
              <ProductCard data={item} />
            </li>
          ))}
      </ul>
        </div>
    </div>
  </div>
);
};

export default SectionSliderProductCard;
